import { PaperProps } from '@mui/material';
import { Dispatch, ReactNode, RefObject, SetStateAction, useRef } from 'react';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography,
} from '@legacy/components/mui-components';

interface IReportingWidgetInfoModal {
  id: string;
  title: string | ReactNode;
  infoMessage: string | ReactNode;
  openState: boolean;
  setOpenState: Dispatch<SetStateAction<boolean>>;
}

const DraggablePaperComponent = ({ id, ...rest }: PaperProps) => {
  const nodeRef = useRef<HTMLDivElement>(null) as RefObject<HTMLDivElement>;

  return (
    <Draggable
      nodeRef={nodeRef}
      handle={`#InfoDialog-Title-${id}`}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <div ref={nodeRef}>
        <Paper {...rest} />
      </div>
    </Draggable>
  );
};
export const ReportingWidgetInfoModal = ({
  id,
  title,
  infoMessage,
  openState,
  setOpenState,
}: IReportingWidgetInfoModal) => {
  const { t } = useTranslation('reportingWidgets');

  return (
    <Dialog
      open={openState}
      onClose={() => setOpenState(false)}
      PaperComponent={DraggablePaperComponent}
      PaperProps={{ id }}
      aria-labelledby={`InfoDialog-Title-${id}`}
      aria-describedby={`InfoDialog-Description-${id}`}
      data-automation-id={`InfoDialog-${id}`}
    >
      <DialogTitle style={{ cursor: 'move' }} id={`InfoDialog-Title-${id}`}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={`InfoDialog-Description-${id}`}>
          {infoMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenState(false)}
          data-automation-id={`${id}InfoModalCloseButton`}
          variant="outlined"
        >
          <Typography>{t('ModalCloseButton').toUpperCase()}</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ReportingWidgetInfoModal;
